// Spinner · indeterminate bar (6 px, sliding fill): work is going on, without progress, time or stages (AC-02).
function IndeterminateBar({ label, className = "" }) {
  return (
    <div role="progressbar" aria-label={label} className={`h-[6px] w-full overflow-hidden rounded-full bg-surface-alt ${className}`}>
      <div
        data-testid="indeterminate-fill"
        className="h-full w-[35%] rounded-full bg-gradient-to-r from-cyan-650 to-cyan-75 animate-indet motion-reduce:animate-none"
      />
    </div>
  );
}

export default IndeterminateBar;
